module.exports = __webpack_public_path__ + "static/img/star.7dbaac4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/particles/images/star.gif
// module id = CAVH
// module chunks = 0